module.exports = __webpack_public_path__ + "static/media/door.3fed513d.jpg";